// for IE11
import "@babel/polyfill";

// for smooth scroll
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// for Navigation
import navigation from './navigation.js';

// for Home
import home from './home.js';

// for Lesson
import lesson from './lesson.js';

// common
( function() {

  // スマホメニューボタン
  let menustate = false;
  let scrollpos;

  const menu = document.getElementsByClassName('menu-toggle').item(0);

  menu.onclick = function() {
    if (menustate == false) {
      menustate = true;
      scrollpos = window.pageYOffset;
      document.body.classList.add('menu-opened');
      document.body.style.top = -scrollpos + 'px';
    } else {
      menustate = false;
      document.body.classList.remove('menu-opened');
      document.body.style.top = '0px';
      window.scrollTo(0, scrollpos);
    }
  };

  const mediaQuery = window.matchMedia('(min-width: 992px)');
//  handle(mediaQuery);
  mediaQuery.addListener(handle);
  function handle(mq) {
    if (mq.matches) {
      menustate = false;
      document.body.classList.remove('menu-opened');
      document.body.style.top = '0px';
      window.scrollTo(0, scrollpos);
      document.getElementById('site-navigation').classList.remove('toggled');
    }
  }

  // ヘッダー
  const nav = document.getElementById('masthead');

  // メニューの高さ
  const ht_point = nav.clientHeight;

  // コンテンツ
  const content = document.getElementById('primary');

  // トップに戻るボタン
  const button2top = document.getElementById('go2top');

  // ボタン表示制御
  function checkScroll() {
    if (menustate == true) {
      return;
    }

    if (window.pageYOffset > (ht_point - 100)) {

      if (nav.classList.contains('downward') == false) {
        nav.classList.add('downward');
        content.style.paddingTop = ht_point + 'px';
      }
    } else {
      if (nav.classList.contains('downward') == true) {
        nav.classList.remove('downward');
        content.style.paddingTop = '0px';
      }
    }
  }

  // スクロール時に判断
  let timeoutId;
  window.onscroll = function() {

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function() {
      checkScroll();
    }, 100);
  }

  // 表示時にも判断
  checkScroll();

  // トップへ移動
  function goToTop() {
    const top = 0;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  }

  // イベント登録
  button2top.onclick = function() {
    goToTop();
  }
}() );
